import React from 'react';
import { ModalWrapper, Option } from './style';
import { FiBell, FiBellOff } from 'react-icons/fi';
import api from '../../config/configAPI';

export const SoundSettingsModal = ({
  show,
  soundEnabled,
  setSoundEnabled,
  login
}) => {
  if (!show) return null;

  const handleToggleSound = async () => {
    const newValue = !soundEnabled;
    try {
      await api.patch(`/user/notification-sound/${login}`, {
        enabled: newValue
      });
      setSoundEnabled(newValue);
    } catch (err) {
      console.error('Erro ao atualizar som:', err);
    }
  };

  return (
    <ModalWrapper>
      <Option onClick={handleToggleSound}>
        {soundEnabled ? (
          <FiBell size={20} color="#333" title="Desativar som" />
        ) : (
          <FiBellOff size={20} color="#333" title="Ativar som" />
        )}
      </Option>
    </ModalWrapper>
  );
};
